import { useState } from "react";
import { darkTheme, lightTheme } from "./themes";
import { initialProducts, initialPromotions } from "./data/mockData";
import LoginPage from "./components/login/LoginPage";
import Sidebar from "./components/Sidebar";
import DashboardPage from "./pages/DashboardPage";
import ProductsPage from "./pages/ProductsPage";
import PromotionsPage from "./pages/PromotionsPage";
import MapPage from "./pages/MapPage";
import PaymentPage from "./pages/PaymentPage";
import DevToolsPage from "./pages/DevToolsPage";

export default function App() {
  const [isDark, setIsDark] = useState(true);
  const [user, setUser] = useState(null);
  const [page, setPage] = useState("dashboard");
  const [products, setProducts] = useState(initialProducts);
  const [promotions, setPromotions] = useState(initialPromotions);

  const t = isDark ? darkTheme : lightTheme;
  const toggleTheme = () => setIsDark((d) => !d);

  if (!user) return (
    <LoginPage
      onLogin={(u) => { setUser(u); setPage("dashboard"); }}
      t={t} isDark={isDark} toggleTheme={toggleTheme}
    />
  );

  const renderPage = () => {
    switch (page) {
      case "dashboard": return <DashboardPage products={products} promotions={promotions} user={user} t={t} />;
      case "products": return <ProductsPage products={products} setProducts={setProducts} t={t} />;
      case "promotions": return <PromotionsPage promotions={promotions} setPromotions={setPromotions} t={t} />;
      case "map": return user.accountType === "admin" ? <MapPage user={user} t={t} /> : <DashboardPage products={products} promotions={promotions} user={user} t={t} />;
      case "payment": return <PaymentPage t={t} />;
      case "devtools": return <DevToolsPage t={t} />;
      default: return <DashboardPage products={products} promotions={promotions} user={user} t={t} />;
    }
  };

  return (
    <div style={{ display: "flex", height: "100vh", background: t.bg, fontFamily: "'Inter', sans-serif", overflow: "hidden" }}>
      <Sidebar
        currentPage={page} onNavigate={setPage}
        user={user} onLogout={() => { setUser(null); setPage("dashboard"); }}
        t={t} isDark={isDark} toggleTheme={toggleTheme}
      />
      <main style={{ flex: 1, overflowY: "auto" }}>
        {renderPage()}
      </main>
    </div>
  );
}